export function pushDataLayer(data) {
  console.log(data, "dataaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa");

  // window.dataLayer = window.dataLayer || [];

  // window.dataLayer.push(data);
}
